var PageConfig = /** @class */ (function () {
    function PageConfig() {
        this.defaults = {
            dashboard: {
                page: {
                    title: 'Dashboard',
                    desc: '*'
                },
            },
            'machine-list': {
                page: {
                    title: 'Machine List',
                    desc: '*'
                }
            },
            'card-readers': {
                page: {
                    title: 'Card Readers',
                    desc: ''
                }
            },
            'cold-brew': {
                page: {
                    title: 'Cold Brew',
                    desc: ''
                }
            },
            'package': {
                'upload': {
                    page: {
                        title: 'Upload Package',
                        desc: '*'
                    }
                },
                'manage': {
                    page: {
                        title: 'Manage Packages',
                        desc: '*'
                    }
                },
                'bundlespec': {
                    page: {
                        title: 'Bundle Spec',
                        desc: '*'
                    }
                }
            },
            'register-machine': {
                page: {
                    title: 'Register Machine',
                    desc: '*'
                }
            },
            'machine-keys': {
                page: {
                    title: 'Machine Keys',
                    desc: '*'
                }
            },
            'member-sales': {
                page: {
                    title: 'Sales by Member',
                    desc: '*'
                }
            },
            users: {
                list: {
                    page: {
                        title: 'Manage Users',
                        desc: ''
                    }
                }
            },
            clients: {
                'list-disti': {
                    page: {
                        title: 'Manage Partner',
                        desc: ''
                    }
                },
                'list-customer': {
                    page: {
                        title: 'Manage Client',
                        desc: ''
                    }
                },
                'list-campus': {
                    page: {
                        title: 'Manage Campus',
                        desc: ''
                    }
                },
                'list-market': {
                    page: {
                        title: 'Manage Markets',
                        desc: ''
                    }
                },
            },
            machine: {
                home: {
                    page: {
                        title: 'Home',
                        desc: ''
                    }
                },
                sales: {
                    page: {
                        title: 'Sales',
                        desc: ''
                    }
                },
                tasks: {
                    page: {
                        title: 'Tasks',
                        desc: ''
                    }
                },
                logs: {
                    page: {
                        title: 'Logs',
                        desc: ''
                    }
                },
                events: {
                    page: {
                        title: 'Events',
                        desc: ''
                    }
                },
                'open-issues': {
                    page: {
                        title: 'Open Issues',
                        desc: ''
                    }
                },
                coil: {
                    page: {
                        title: 'Planogram',
                        desc: ''
                    }
                },
                updates: {
                    page: {
                        title: 'Updates',
                        desc: ''
                    }
                },
                remote: {
                    page: {
                        title: 'Remote Control',
                        desc: ''
                    }
                },
                'auger-purge': {
                    page: {
                        title: 'Auger Purge',
                        desc: ''
                    }
                },
                'canister-type': {
                    page: {
                        title: 'Canister Type',
                        desc: ''
                    }
                },
                about: {
                    page: {
                        title: 'About',
                        desc: ''
                    }
                },
                details: {
                    page: {
                        title: 'Machine Details',
                        desc: ''
                    }
                },
                'card-reader': {
                    page: {
                        title: 'Card Reader',
                        desc: ''
                    }
                },
                'cold-brew': {
                    page: {
                        title: 'Cold Brew',
                        desc: ''
                    }
                },
                keys: {
                    page: {
                        title: 'Scrubport Keys',
                        desc: ''
                    }
                }
            },
            'user-settings': {
                profile: {
                    page: {
                        title: 'User Profile',
                        desc: ''
                    }
                },
                notification: {
                    page: {
                        title: 'Notifications',
                        desc: ''
                    }
                }
            },
            analytics: {
                page: {
                    title: 'Analytics',
                    desc: ''
                }
            },
            audits: {
                page: {
                    title: 'Audits',
                    desc: ''
                },
                fleet: {
                    page: {
                        title: 'Fleet',
                        desc: ''
                    }
                },
                triage: {
                    page: {
                        title: 'Triage',
                        desc: ''
                    }
                },
                analytics: {
                    page: {
                        title: 'Analytics',
                        desc: ''
                    }
                },
                machine: {
                    page: {
                        title: 'Machine Detail',
                        desc: ''
                    }
                }
            },
            inventory: {
                campus: {
                    page: {
                        title: 'Campus Inventory',
                        desc: ''
                    }
                },
                market: {
                    page: {
                        title: 'Market Inventory',
                        desc: ''
                    }
                }
            },
            orders: {
                page: {
                    title: 'Orders',
                    desc: ''
                }
            },
            voucher: {
                page: {
                    title: 'Vouchers',
                    desc: ''
                }
            },
            'voucher-ops': {
                page: {
                    title: 'Voucher ops',
                    desc: ''
                }
            },
            flex: {
                page: {
                    title: 'VendiBean Flex',
                    desc: ''
                }
            },
            'new-dashboard': {
                page: {
                    title: 'New Dashboard',
                    desc: ''
                }
            },
            error: {
                404: {
                    page: { title: '404 Not Found', desc: '', subheader: false }
                },
                403: {
                    page: { title: '403 Access Forbidden', desc: '', subheader: false }
                }
            },
            wizard: {
                'wizard-1': { page: { title: 'Wizard 1', desc: '' } },
                'wizard-2': { page: { title: 'Wizard 2', desc: '' } },
                'wizard-3': { page: { title: 'Wizard 3', desc: '' } },
                'wizard-4': { page: { title: 'Wizard 4', desc: '' } },
            },
        };
    }
    Object.defineProperty(PageConfig.prototype, "configs", {
        get: function () {
            return this.defaults;
        },
        enumerable: true,
        configurable: true
    });
    return PageConfig;
}());
export { PageConfig };
